import type { Content } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"

import { FAQs } from "../../components/Generic/FAQs/FAQs"

/**
 * Props for `Faq`.
 */
export type FaqSliceProps = SliceComponentProps<Content.FaqSlice>

/**
 * Component for "Faq" Slices.
 */
const FaqSlice = ({ slice }: FaqSliceProps): React.JSX.Element => {
  const faqs = slice.items.map(item => ({
    answer: item.answer ?? "",
    question: item.question ?? "",
    id: item.questionId ?? "",
  }))

  return <FAQs {...slice.primary} faqs={faqs} />
}

export default FaqSlice
